var _path, _path2, _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _g2, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentDoneSkyfert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 354,
    viewBox: "0 0 320 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8734 45.6291C12.3017 70.5841 14.7451 118.599 42.9007 121.691C71.0563 124.783 69.5767 85.5556 98.9738 84.8285C128.371 84.1014 143.584 58.9883 123.573 40.3783C103.563 21.7683 59.4452 20.6741 35.8734 45.6291Z",
    fill: "#F9F1FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.449 353.612C307.847 345.811 382.059 147.64 252.289 70.7274C175.835 25.4146 186.505 113.327 123.968 143.747C72.4184 168.822 39.3923 139.277 17.3511 172.991C-32.8006 249.702 45.0502 361.414 176.449 353.612Z",
    fill: "#F9F1FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 89,
    width: 139,
    height: 165,
    rx: 5,
    fill: "#BD8AAD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 84,
    width: 139,
    height: 164,
    rx: 5,
    fill: "#85CCCA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5035_260881",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 84,
    width: 139,
    height: 164
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 84,
    width: 139,
    height: 164,
    rx: 5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5035_260881)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.323 59.0469L98.3805 14.0469L-17.0621 213.999L60.8802 258.999L176.323 59.0469Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 122,
    width: 139,
    height: 164,
    rx: 5,
    fill: "#BD8AAD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 117,
    width: 139,
    height: 164,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5035_260881",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 117,
    width: 139,
    height: 164
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 117,
    width: 139,
    height: 164,
    rx: 5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5035_260881)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172 180C229.99 180 277 132.99 277 75C277 17.0101 229.99 -30 172 -30C114.01 -30 67 17.0101 67 75C67 132.99 114.01 180 172 180Z",
    fill: "#FDF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.40548,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.115 99.4922L199.693 74.9999L139 180.123L181.422 204.616L242.115 99.4922Z",
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 198,
    width: 83,
    height: 7,
    rx: 3.5,
    fill: "#FDF5FD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 212,
    width: 64,
    height: 7,
    rx: 3.5,
    fill: "#FDF5FD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 261,
    width: 20,
    height: 7,
    rx: 3.5,
    fill: "#FDF5FD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 261,
    width: 20,
    height: 7,
    rx: 3.5,
    fill: "#FDF5FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217 315C241.853 315 262 294.853 262 270C262 245.147 241.853 225 217 225C192.147 225 172 245.147 172 270C172 294.853 192.147 315 217 315Z",
    fill: "#744164"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221 311C245.853 311 266 290.853 266 266C266 241.147 245.853 221 221 221C196.147 221 176 241.147 176 266C176 290.853 196.147 311 221 311Z",
    fill: "#BD8AAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203 273.813L215.742 287L237 265",
    stroke: "#744164",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205 267.813L217.742 281L239 259",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentDoneSkyfert);
export default __webpack_public_path__ + "static/media/appointment_done_skyfert.b30367d7c5a61090ddeb552154abd8da.svg";
export { ForwardRef as ReactComponent };